import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { DataProvider } from '@/context/DataContext';
import AppLayout from '@/components/layout/AppLayout';
import LoginScreen from '@/components/auth/LoginScreen';
import Dashboard from '@/pages/Dashboard';
import QuoteWizard from '@/pages/QuoteWizard';
import QuoteView from '@/pages/QuoteView';
import DiscountAdmin from '@/pages/DiscountAdmin';
import PublicProposal from '@/pages/PublicProposal';

export default function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Routes>
          {/* Pública (sin auth) */}
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/p/:token" element={<PublicProposal />} />

          {/* Protegidas */}
          <Route element={<AppLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/cotizacion/nueva" element={<QuoteWizard />} />
            <Route path="/cotizacion/:id/editar" element={<QuoteWizard />} />
            <Route path="/cotizacion/:id" element={<QuoteView />} />
            <Route path="/descuentos" element={<DiscountAdmin />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </DataProvider>
    </AuthProvider>
  );
}
